/** Shared company WhatsApp number and prefilled consultation message. */
export const COMPANY_WHATSAPP = '963933612861';

export const CONSULTATION_WHATSAPP_MESSAGE = [
  'مرحباً شركة الشراع،',
  'أريد التواصل بخصوص التخليص الجمركي.',
  'أُدرك أن الاستشارات الجمركية ودراسة الأسعار خدمة مدفوعة وليست مجانية.',
].join('\n');

export const consultationWhatsAppUrl = (): string =>
  `https://wa.me/${COMPANY_WHATSAPP}?text=${encodeURIComponent(CONSULTATION_WHATSAPP_MESSAGE)}`;
